// cust
$narwal.on('DOMContentLoaded', () => {
  $narwal.on('click', function(e) {
    const el = e.target;
    // global select div icon - Yudi
    if(el.classList.contains('global-select-div-icon') || el.closest('.global-select-div-icon')) {
      const selectDivEl = el.classList.contains('global-select-div-icon') ? el : el.closest('.global-select-div-icon');

      document.querySelectorAll('.global-select-div-icon.active').forEach(function(gsd) {
        if(gsd != selectDivEl) {
          gsd.classList.remove('active');
        }
      });

      if(selectDivEl.classList.contains('active')) {
        selectDivEl.classList.remove('active');
      } else {
        selectDivEl.classList.add('active');
      }
    } else {
      document.querySelectorAll('.global-select-div-icon.active').forEach(function(gsd) {
        gsd.classList.remove('active');
      });
    }
    if(el.classList.contains('option') && el.closest('.global-select-div-icon')) {
      const optionEl = el;
      const select = optionEl.closest('.options').nextElementSibling;
      select.value = optionEl.getAttribute('data-value');
      select.dispatchEvent(new Event('change'));
      select.closest('.global-select-div-icon').querySelector('.inner .text').innerHTML = optionEl.innerHTML;
    }
  });
  function addStarProduct(elem, type, callback){

    document.querySelectorAll(elem).forEach(function(elem){

        elem.onclick = function(e){

            e.preventDefault();

            // Show page loader
            const loader = document.getElementById("lp-page-loader");
            if (loader) {
                loader.classList.add("active");
            }

            var quantity = 1;

            let formData = {
                'items': [{
                    'id': elem.getAttribute('data-variant-id'),
                    'quantity': quantity
                }]
            };

            fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Product could not be added');
                }
                return response.json();
            })
            .then(function(json) {

                if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
                    window.cart_clear = false;
                    window.promotionValidate();
                }

                setTimeout(function(){

                    if(type == 'checkout'){

                        window.location.href = '/checkout?locale=he';

                    } else {

                        if (callback) callback();

                        setTimeout(function() {
                            $360.showHeaderCart({ update: true });

                            // Hide loader after cart drawer update
                            if (loader) {
                                loader.classList.remove("active");
                            }

                        }, 300);

                    }

                }, 1000);

            })
            .catch(function(error) {

                console.error(error);

                if (loader) {
                    loader.classList.remove("active");
                }

                alert('Something went wrong. Please try again.');

            });

        };

    });

}
 
  // Existing checkout button
if(document.querySelectorAll('.checkoutButton').length > 0){
  addStarProduct('.checkoutButton', 'checkout');
}

// Black November custom buttons
if(document.querySelectorAll('.lp-add-to-cart').length > 0){
  addStarProduct('.lp-add-to-cart', 'cart');
}

if(document.querySelectorAll('.lp-buy-now').length > 0){
  addStarProduct('.lp-buy-now', 'checkout');
}
});
